/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListAdministrator } from '../../models/api-response-list-administrator';

export interface ListAdministrator$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function listAdministrator(http: HttpClient, rootUrl: string, params: ListAdministrator$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAdministrator>> {
  const rb = new RequestBuilder(rootUrl, listAdministrator.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListAdministrator>;
    })
  );
}

listAdministrator.PATH = '/v1/api/admin-ui/administrator/list';
